import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';
import { THEME } from '../../../../../constants';


export const Title = styled.p`
  color: ${THEME.grey};
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  margin: 0;
`;

export const Text = styled.p`
  color: ${THEME.bobBlack};
  display: flex;
  flex-direction: row;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
`;

export const Span = styled.span`
  color: ${THEME.grey};
  margin-right: 10px;
  user-select: none;
`;

export const LightSpan = styled(Span)`
  font-weight: 300;
`;

export const PaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.8;
`;

export const Stripe = styled.a`
  color: ${THEME.grey};
  cursor: pointer;
  display: inline;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;  
  margin: 0;
  text-decoration: underline;
`;

export const StripeContainer = styled.div``;

export const usePaymentInfoStyles = makeStyles(theme => ({
  root: {
    display                     : 'grid',
    gridTemplateColumns         : '1fr',
    gridGap                     : theme.spacing(2),
    width                       : '100%',
    maxWidth                    : '320px',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '100px 1fr',
    },
  },
}));
